import { Injectable} from "@angular/core";
import { CookieService } from "ngx-cookie-service";
import { Permission } from "@nucleus/user-ui";
import { Profile } from "../api/authentication-service";

@Injectable({providedIn: 'root'})
export class ApplicationConfigService {

    private authorities : string[] = [];
    private permissions: Permission[] = [];
    /** Every route that has a rule entry in navigation-rules.json. Used to
     *  distinguish "no rule → default allow" from "rule exists, user denied". */
    private knownRoutes : Set<string> = new Set();
    /** Server-resolved permitted routes (from BFF /bootstrap). Populated
     *  once at startup. Route guards just check Set.has(route) — no need
     *  for the SPA to download + evaluate the navigation-rules.json map. */
    private permittedRoutes : Set<string> = new Set();
    private userId : string = "";

    constructor(private cookieService : CookieService) {}

    clear() : void {
        // Preserve user-scoped UI preferences across the session-clear so the
        // user keeps their bookmarked route + theme after the auth round-trip.
        const bookmark = window.sessionStorage.getItem('ts_redirect');
        const theme = window.localStorage.getItem('ts-theme');

        this.userId = "";
        this.cookieService.deleteAll();
        this.authorities = [];
        this.permissions = [];
        this.knownRoutes.clear();
        this.permittedRoutes.clear();
        window.localStorage.clear();
        window.sessionStorage.clear();

        if (bookmark) {
            window.sessionStorage.setItem('ts_redirect', bookmark);
        }
        if (theme) {
            window.localStorage.setItem('ts-theme', theme);
        }
    }

    set(profile : Profile) {
        this.userId = profile.userId ?? "";
        this.authorities = profile.authorities ?? [];
    }

    getUserId() : string {
        return this.userId;
    }

    getAuthorities() : string[] {
        return this.authorities;
    }


    /** BFF-resolved permitted routes (from /bootstrap). Single source of
     *  truth: the SPA never sees the rule map nor evaluates authorities
     *  client-side. */
    setPermittedRoutes(routes: string[]) : void {
        this.permittedRoutes = new Set(routes);
    }

    isRoutePermitted(route: string) : boolean {
        return this.permittedRoutes.has(route);
    }

    setKnownRoutes(routes: string[]) : void {
        this.knownRoutes = new Set(routes);
    }

    isRouteKnown(route: string) : boolean {
        return this.knownRoutes.has(route);
    }

    getPermissions() : Permission[] {
        return this.permissions;
    }

    setPermissions(permissions : Permission[]) : void{
        this.permissions = permissions;
    }

}
